export default __webpack_public_path__ + "static/media/water-boiling.58185322.mp3";